var _g, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _line, _line2, _rect6, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurschaseInvoiceNewUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 235,
    viewBox: "0 0 235 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_936_5956_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.097781 0.234674 -0.234674 -0.097781 117.5 117.608)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.588,
    height: 605.588,
    fill: "url(#paint0_diamond_936_5956)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.588,
    height: 605.588,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_936_5956)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.588,
    height: 605.588,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_936_5956)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.588,
    height: 605.588,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_936_5956)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 117.608,
    r: 117,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.062745101749897003,\"g\":0.63921570777893066,\"b\":0.49803921580314636,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.64999997615814209},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.65206468105316162}],\"stopsVar\":[{\"color\":{\"r\":0.062745101749897003,\"g\":0.63921570777893066,\"b\":0.49803921580314636,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.64999997615814209},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.65206468105316162}],\"transform\":{\"m00\":-195.56198120117188,\"m01\":-469.34872436523438,\"m02\":449.95535278320312,\"m10\":469.34872436523438,\"m11\":-195.56198120117188,\"m12\":-19.285459518432617},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 41.6079,
    width: 199,
    height: 153,
    rx: 5.86743,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 104.608,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 142.608,
    width: 62,
    height: 19,
    rx: 4,
    fill: "#10A37F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 104.608,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 66.6079,
    width: 92.4121,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36.5,
    y1: 93.1079,
    x2: 198.5,
    y2: 93.1079,
    stroke: "#D9D9D9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36.5,
    y1: 125.108,
    x2: 198.5,
    y2: 125.108,
    stroke: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 172.608,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#E8E9ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.201 196.452L126.639 191.783C126.62 191.628 126.43 191.563 126.32 191.673L124.93 193.065L118.572 186.709C118.424 186.563 118.187 186.563 118.042 186.709L115.656 189.092L109.171 182.607C109.136 182.572 109.088 182.553 109.038 182.553C108.989 182.553 108.941 182.572 108.906 182.607L107.851 183.667C107.816 183.702 107.797 183.749 107.797 183.799C107.797 183.849 107.816 183.896 107.851 183.931L115.391 191.476C115.536 191.624 115.776 191.624 115.921 191.476L118.307 189.092L123.606 194.389L122.216 195.779C122.191 195.804 122.174 195.835 122.166 195.87C122.158 195.904 122.16 195.94 122.172 195.973C122.183 196.006 122.204 196.035 122.231 196.057C122.258 196.08 122.291 196.094 122.326 196.098L126.995 196.66C127.115 196.677 127.218 196.574 127.201 196.452Z",
    fill: "#10A37F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_936_5956_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 117.608,
    r: 117
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_936_5956",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E8E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652065,
    stopColor: "#E8E9ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurschaseInvoiceNewUserIcon);
export default __webpack_public_path__ + "static/media/PurschaseInvoiceNewUserIcon.6030af601f9f169b37cf5b15d027ec67.svg";
export { ForwardRef as ReactComponent };